_options$depth